import { getCurrentLocalDateTime } from "./getLocalDateTime";

export const calculatorInstallmentStatus = (installments) => {
  let total_late = 0;
  let prevIndex = 0;
  for (let index = 0; index < installments.length; index++) {
    const installment = installments[index];
    const total = installment.actualInterest + installment.actualPrinciple;
    let plan_total = installment.planInterest + installment.planPrinciple;
    const today = getCurrentLocalDateTime();
    const paid_date = getCurrentLocalDateTime(new Date(installment.paid_date));

    if (plan_total > installment.planCapitalRemain) {
      plan_total = installment.planCapitalRemain;
    }

    console.log("index", index);
    // console.log("total_late", total_late);

    // if (index === 0) {
    //   let cal_paid_amount = installment.paid_amount - plan_total;
    //   if (cal_paid_amount >= 0) {
    //     installment.displayStatus = "ปิด-ตรงเวลา";
    //     prevIndex++;
    //   } else if (installment.actualInterest + installment.actualPrinciple > 0) {
    //     installment.displayStatus = "ค้างชำระ";
    //   }
    // } else {
    //   console.log("prevIndex", prevIndex);

    //   let prev_total_plan =
    //     installments[prevIndex].planInterest +
    //     installments[prevIndex].planPrinciple;
    //   let cal_current_paid_amount = installment.paid_amount - prev_total_plan;
    //   console.log("original cal_current_paid_amount", cal_current_paid_amount);
    //   console.log("installment", installment.paid_amount);
    //   if (installment.actualInterest + installment.actualPrinciple > 0) {
    //     installment.displayStatus = "ค้างชำระ";
    //   }

    //   let currentIndex = prevIndex;
    //   do {
    //     if (currentIndex > installments.length) {
    //       console.log("break");
    //       break;
    //     }

    //     if (cal_current_paid_amount >= 0) {
    //       const prevInstallment = installments[currentIndex];
    //       let prev_total_actual =
    //         prevInstallment.actualInterest + prevInstallment.actualPrinciple;
    //       let prev_total_plan =
    //         prevInstallment.planInterest + prevInstallment.planPrinciple;

    //       console.log("cal_paid_amount", cal_current_paid_amount);
    //       console.log("currentIndex", currentIndex);
    //       if (
    //         paid_date.fullDate <= prevInstallment.date &&
    //         prev_total_actual <= 0 &&
    //         prevInstallment.paid_amount >= prev_total_plan
    //       ) {
    //         console.log("case 1");
    //         installment.displayStatus = "ปิด-ตรงเวลา";
    //         prevIndex++;
    //       } else if (prev_total_actual > 0) {
    //         console.log("case 2");
    //         prevInstallment.displayStatus = "ค้างชำระ";
    //       } else if (cal_current_paid_amount >= prev_total_plan) {
    //         console.log("case 3");
    //         prevInstallment.displayStatus = "ปิด-เลท";
    //         prevIndex++;
    //       } else if (
    //         cal_current_paid_amount === 0 &&
    //         prevInstallment.paid_amount === 0
    //       ) {
    //         console.log("case 4");
    //         prevInstallment.displayStatus = "ปิด-เลท";
    //         prevIndex++;
    //       }

    //       // if (prevInstallment.displayStatus === "ปิด-ตรงเวลา") {
    //       //   prevIndex = currentIndex + 1;
    //       // }
    //       cal_current_paid_amount -=
    //         prevInstallment.planInterest + prevInstallment.planPrinciple;
    //     }
    //     currentIndex++;
    //   } while (cal_current_paid_amount >= 0);
    // }

    // if (!installment.disabledPeriod) {
    //   installment.displayStatus = "เปิด";
    // }

    // if (installment.planCapitalRemain === 0) {
    //   installment.displayStatus = "ปิด-โปะ";
    // }

    if (installment.disabledPeriod) {
      // if (
      //   installment.paid_amount >= plan_total &&
      //   paid_date.fullDate <= installment.date &&
      //   total <= 0
      // ) {
      //   console.log("ปิด ตรงเวลา");
      //   installment.displayStatus = "ปิด-ตรงเวลา";
      //   let cal_late = installment.paid_amount - total_late;
      //   console.log("cal late", cal_late);
      //   if (installment.paid_amount <= total_late) {
      //     console.log("ปิด-เลท");
      //     installment.displayStatus = "ปิด-เลท";
      //     // total_late -= installment.paid_amount;
      //     // total_late = 0
      //   }
      //   if (installment.disabledPeriod) {
      //     console.log("3");
      //     let cal_paid_amount = installment.paid_amount - total_late;
      //     console.log("cal_paid_amount", cal_paid_amount);
      //     console.log("total_late", total_late);
      //     if (cal_paid_amount > 0 && cal_paid_amount !== plan_total) {
      //       console.log("3.1");
      //       if (
      //         installment.paid_amount > total_late &&
      //         installment.paid_amount >= plan_total
      //       ) {
      //         console.log("3.1.1");
      //         const cal_current_eq =
      //           total_late +
      //           installment.planInterest +
      //           installment.planPrinciple;
      //         console.log("cal_current_eq", cal_current_eq);
      //         if (
      //           cal_current_eq - installment.paid_amount >= plan_total ||
      //           installment.paid_amount >= cal_current_eq
      //         ) {
      //           installment.displayStatus = "ปิด-ตรงเวลา";
      //           console.log("3.1.1.1");
      //         } else {
      //           installment.displayStatus = "ปิด-เลท";
      //           console.log("3.1.1.2");
      //         }
      //       } else {
      //         console.log("3.1.2");
      //         installment.displayStatus = "ปิด-เลท";
      //       }
      //     }
      //     // if (cal_late < 0) {
      //     //   console.log("3.2");
      //     //   installment.displayStatus = "ปิด-ตรงเวลา";
      //     // }
      //   }
      //   if (
      //     index === installments.length - 1 &&
      //     installment.paid_amount >= plan_total
      //   ) {
      //     console.log("1");
      //     installment.displayStatus = "ปิด-ตรงเวลา";
      //   }
      // } else if (total > 0) {
      //   installment.displayStatus = "ค้างชำระ";
      //   console.log("ค้างชำระ");
      // } else if (
      //   today > installment.date &&
      //   installment.paid_amount < plan_total
      // ) {
      //   console.log("plan_total", plan_total);
      //   installment.displayStatus = "ปิด-เลท";
      //   total_late += installment.planInterest + installment.planPrinciple;
      //   if (installment.paid_amount > 0) {
      //     total_late -= installment.paid_amount;
      //   }
      //   console.log("ปิด-เลท outside");
      // }
      // if (installment.planCapitalRemain === 0) {
      //   installment.displayStatus = "ปิด-โปะ";
      // }
      //   // if (total > 0) {
      //   //   installment.displayStatus = "ค้างชำระ";
      //   // }
      //   // if (installment.paid_amount >= plan_total) {
      //   //   installment.displayStatus = "ปิด-ตรงเวลา";
      //   // }
      //   // if (installment.planCapitalRemain === 0) {
      //   //   installment.displayStatus = "ปิด-โปะ";
      //   // }
      //   // if (total === 0 && today.fullDate > installment.date) {
      //   //   installment.displayStatus = "ปิด-เลท";
      //   // }
    } else {
      installment.displayStatus = "เปิด";
    }

    if (installment.paid_amount > total_late) {
      total_late = 0;
    }

    console.log("-------------------");
  }

  return installments;
};

export const calculatorDisabledPeriodRemain = (
  installments,
  paid_date = new Date()
) => {
  let disabledPeriodRemain = 0;
  let matchIndex = 0;
  let countDisabled = 0;
  for (let index = 0; index < installments.length; index++) {
    const installment = installments[index];
    const today = getCurrentLocalDateTime(new Date(paid_date));
    const checkPeriod = today.fullDate <= installment.date;

    if (installment.disabledPeriod) {
      countDisabled++;
      if (countDisabled !== installments.length) {
        disabledPeriodRemain +=
          installment.actualInterest + installment.actualPrinciple;
      }
    }

    if (checkPeriod && !matchIndex && !installment.disabledPeriod) {
      matchIndex = index;
    }
  }

  if (countDisabled === installments.length) {
    matchIndex = installments.length - 1;
  }

  return { disabledPeriodRemain, matchIndex };
};

export const getCheckCurrentDate = (installments = []) => {
  let currentIndex = 0;
  let today = getCurrentLocalDateTime();
  for (let index = 0; index < installments.length; index++) {
    const installment = installments[index];
    if (
      today.fullDate <=
      getCurrentLocalDateTime(new Date(installment.date)).fullDate
    ) {
      currentIndex = index;
      break;
    }
  }
  return currentIndex;
};

export const getTotalAmount = (
  checkCurrentDate,
  loan,
  installment,
  myIndex
) => {
  let { installments = [] } = loan;
  let total = installment.actualPrinciple + installment.actualInterest;
  if (checkCurrentDate) {
    for (let index = 0; index < myIndex; index++) {
      const installment = installments[index];
      if (installment.disabledPeriod) {
        total += installment.actualPrinciple + installment.actualInterest;
      }
    }
  }
  return total;
};

export const calPayPerMonth = (interest_year, budget, period) => {
  const totalPaymentPerMonthly = (budget * (interest_year / 100)) / 12;

  const payPerMonth = totalPaymentPerMonthly + budget / period;
  return payPerMonth;
};
